import { UpperPanelProps } from "./types/upperPanelProps";
import logo from '../../../images/logo.png';
import Image from '../../../components/shared/image/image';
import ButtonField from "../../../components/buttonField/buttonField";
import { ButtonFieldProps } from "../../../components/buttonField/types/buttonFieldProps";
import { BtnProps, classNameBtn } from "../../../components/shared/button/types/buttonProps";
import UseDebounce from '../../../helpers/debounce';
import UserField from "../../../components/userField/userField";
import './upperPanel.scss';
import OnlineField from "../../../components/onlineField/onlineField";
import NotificationBadge from "../../topbar/notificationBadge/notificationBadge";
import AuthContext from "../../../contexts/authContext";
import { useContext, useState } from "react";
import PermissionsContext from "../../../contexts/permissionsContext";
import WriteMessage from "../../topbar/writeMessage/writeMessage";

const UpperPanel = (props: UpperPanelProps) => {
    const { onlineMode } = useContext(AuthContext);
    const { functionsPermissions } = useContext(PermissionsContext);
    const [writeMessage, setWriteMessage] = useState<boolean>(false);

    const writeMsg = (event: React.MouseEvent<HTMLButtonElement>) => {
        setWriteMessage(true);
    }

    const handleCloseMsg = () => {
        setWriteMessage(false);
    }

    var btnProps: BtnProps = {
        onClick: UseDebounce(writeMsg, 100),
        style: {
            minWidth: '170px'
        },
        className: classNameBtn.SmallSecondary
    }

    var buttonFieldProps: ButtonFieldProps = {
        BtnProps: btnProps,
        placeHolder: "Napisz wiadomość"
    }

    return (
        <div className="upperPanelContent">
            <Image src={logo} />
            {functionsPermissions.sendMessages.active ? <ButtonField {...buttonFieldProps}></ButtonField> : <div></div>}
            {onlineMode && functionsPermissions.userNotifications.active? <NotificationBadge /> : <div></div>}
            <UserField />
            <OnlineField />
            {writeMessage && <WriteMessage onClose={handleCloseMsg}/>}
        </div>
    )
}

export default UpperPanel;